module.exports = __webpack_public_path__ + "img/zgkxy.b5f9160b.png";